import type { DocumentId, DocumentRevision, UserId } from 'core/types';

export type CommentLinkModel = {
  entityType: string;
  entityID: DocumentId;
};
export class CommentModel {
  _id: DocumentId;

  _rev: DocumentRevision;

  text: string;

  authorID: UserId;

  link: CommentLinkModel;

  createdAtUTC: Date;
}
